import delay from "lodash/delay";
import defer from "lodash/defer";
import min from "lodash/min";
import max from "lodash/max";
import indexOf from "lodash/indexOf";
import uniq from "lodash/uniq";

window._lodash = {
  delay: delay,
  defer: defer,
  min: min,
  max: max,
  indexOf: indexOf,
  uniq: uniq,
};
